<template>
  <div :class="{ 'form-loading': loading }">
    <window-header></window-header>
    <nav style="justify-content: space-between;">
      <r-progressbar :value="progressbar" v-if="progressbar"></r-progressbar>
      <template v-else>
        <button class="button button-fill" @click="abrirConfiguracion">
          <fa-icon icon="filter" /><span>Filtros</span>
        </button>
        <div style="display: flex; align-items: center;">{{ hotInstance ? (hotInstance.getSourceData().length + ' ' +
          (hotInstance.getSourceData().length == 1 ?
            'artículo' : 'artículos')) : '' }}</div>
        <div style="display: flex;">
          <label style="display: flex; align-items: center;">
            <input type="checkbox" name="inactivos" v-model="mostrarInactivos" @change="actualizarArticulos">
            <span style="margin-left: 5px;">Mostrar inactivos</span>
          </label>
          <label style="display: flex; align-items: center; margin-left: 15px;">
            <input type="checkbox" name="sin_stock" v-model="mostrarSinStock" @change="actualizarArticulos">
            <span style="margin-left: 5px;">Mostrar sin stock</span>
          </label>
        </div>
        <button class="button button-fill" @click="guardar">
          <fa-icon icon="save" /> <span>Guardar</span>
        </button>
      </template>
    </nav>
    <section>
      <article style="height: 536px; width: 975px">
        <div ref="hotTableComponent"></div>
      </article>
    </section>
  </div>
</template>

<script>
import WindowMixin from "./../components/WindowMixin.vue";
import Handsontable from "handsontable";

export default {
  mixins: [WindowMixin],
  data: function () {
    return {
      title: "Tarifas de artículos",
      hotInstance: null,
      loading: false,
      mostrarInactivos: false,
      mostrarSinStock: false,
      progressbar: 0,
      actualizarArticulos: null,
    };
  },
  methods: {
    guardar() {
      let self = this;
      let data = self.hotInstance.getSourceData().filter(d => d.changed)
      if (!data.length) {
        self.app.toast("No se ha modificado ninguna línea", "error")
        return;
      }
      self.loading = true;
      let p = Promise.resolve();
      data.forEach((item, i) => {
        p = p.then(_ => {
          self.progressbar = Math.floor((i * 100) / data.length);
          return window.DB.put('articulo', {
            itemId: item.codigo, data: {
              tarifa1: item.tarifa1,
              tarifa2: item.tarifa2,
              tarifa3: item.tarifa3,
              tarifa4: item.tarifa4,
              tarifa5: item.tarifa5,
              tarifa6: item.tarifa6,
              tarifa7: item.tarifa7,
              tarifa8: item.tarifa8,
              tarifa9: item.tarifa9,
              tarifa10: item.tarifa10,
            }
          })
        });
      })
      p
        .catch(e => self.app.toast("Error al actualizar los artículos", "error"))
        .then(_ => self.app.toast("Artículos actualizados", "success"))
        .finally(_ => {
          self.loading = false
          self.progressbar = 0
        })
    },
    abrirConfiguracion() {
      var self = this;
      self.app.openChildWindow("articulos_tarifas_config", self.win, {
        backdrop: true,
        //model: self.model,
        props: {
          parent: self,
        },
      });
    },
  },
  mounted() {
    var self = this;

    self.filtro = null;

    self.actualizarArticulos = (forceVal) => {
      self.loading = true;
      let filter = [];
      if (!self.mostrarInactivos) filter.push(['activo', '=', 1])
      if (!self.mostrarSinStock) filter.push(['stock', '>', 0])
      if (self.filtro) filter.push(self.filtro);
      window.DB.getList('articulo', { filter, order: 'codigo', fields: [{ name: 'thumbnail', fields: ['imagen'] }, 'codigo', 'nombre', 'fecha_ultima_compra', 'peso_unitario', 'coste_unidad_venta', 'stock', 'tarifa1', 'tarifa2', 'tarifa3', 'tarifa4', 'tarifa5', 'tarifa6', 'tarifa7', 'tarifa8', 'tarifa9', 'tarifa10', 'descuento_web'] }).then(resArt => {
        let data = resArt.data.map(a => ({ ...a, ...{ changed: typeof forceVal != 'undefined' } }));
        self.hotInstance.loadData(data);
      }).finally(_ => self.loading = false)
    }

    const rowHeaderWidth = 40;
    const checkboxWidth = 35;
    const codigoWidth = 100;
    const ucompraWidth = 70;
    const pesoWidth = 55;
    const costeWidth = 55;
    const stockWidth = 55;
    const pcgr = 55;
    const t1gr = 55;
    const tarifaWidth = 55;
    const dtoWidth = 55;
    const descripcionWidth = Math.max(975 - rowHeaderWidth - 10 - codigoWidth - ucompraWidth - pcgr - t1gr - pesoWidth - costeWidth - stockWidth - 10 * tarifaWidth, 200);
    const colHeaders = ['Código', 'Descripción', 'U.Compra', 'Peso', 'PC/ud', 'Stock', 'PC/gr', 'T1/gr', 'T1', 'T2', 'T3', 'T4', 'T5', 'T6', 'T7', 'T8', 'T9', 'T10', 'Dto.'];
    const colWidths = checkboxWidth;
    let columns = [
      {
        data: 'codigo',
        readOnly: true,
        width: codigoWidth,
        renderer: function (hotInstance, td, row, column, prop, value, cellProperties) {
          Handsontable.renderers.TextRenderer.apply(this, arguments);
          let r = self.hotInstance?.toPhysicalRow(row) || row;
          if (hotInstance.getSourceDataAtRow(r).changed) td.style.backgroundColor = '#fff3bb';
        },
        columnSorting: {
          compareFunctionFactory: function compareFunctionFactory(sortOrder, columnMeta) {
            return function comparator(a, b) {
              //window.console.log(a, b, sortOrder, (a[order] > b[order] ? 1 : (a[order] < b[order] ? -1 : 0)) * (sortOrder == 'asc' ? 1 : -1))
              return (a > b ? 1 : (a < b ? -1 : 0)) * (sortOrder == 'asc' ? 1 : -1);
            };
          }
        }
      },
      { data: 'nombre', readOnly: true, width: descripcionWidth },
      { data: 'fecha_ultima_compra', type: 'date2', readOnly: true, width: ucompraWidth },
      { data: 'peso_unitario', type: 'numeric', readOnly: true, numericFormat: { pattern: '0,0.00' }, width: dtoWidth },
      { data: 'coste_unidad_venta', type: 'numeric', readOnly: true, numericFormat: { pattern: '0,0.00' }, width: costeWidth },
      { data: 'stock', type: 'numeric', readOnly: true, numericFormat: { pattern: '0,0.00' }, width: stockWidth },
      { type: 'numeric', readOnly: true, numericFormat: { pattern: '0,0.00' }, width: pcgr, data: row => row.coste_unidad_venta / (row.peso_unitario || 1) },
      { type: 'numeric', readOnly: true, numericFormat: { pattern: '0,0.00' }, width: t1gr, data: row => row.tarifa1 / (row.peso_unitario || 1) },
      { data: 'tarifa1', type: 'numeric', numericFormat: { pattern: '0,0.00' }, width: tarifaWidth },
      { data: 'tarifa2', type: 'numeric', numericFormat: { pattern: '0,0.00' }, width: tarifaWidth },
      { data: 'tarifa3', type: 'numeric', numericFormat: { pattern: '0,0.00' }, width: tarifaWidth },
      { data: 'tarifa4', type: 'numeric', numericFormat: { pattern: '0,0.00' }, width: tarifaWidth },
      { data: 'tarifa5', type: 'numeric', numericFormat: { pattern: '0,0.00' }, width: tarifaWidth },
      { data: 'tarifa6', type: 'numeric', numericFormat: { pattern: '0,0.00' }, width: tarifaWidth },
      { data: 'tarifa7', type: 'numeric', numericFormat: { pattern: '0,0.00' }, width: tarifaWidth },
      { data: 'tarifa8', type: 'numeric', numericFormat: { pattern: '0,0.00' }, width: tarifaWidth },
      { data: 'tarifa9', type: 'numeric', numericFormat: { pattern: '0,0.00' }, width: tarifaWidth },
      { data: 'tarifa10', type: 'numeric', numericFormat: { pattern: '0,0.00' }, width: tarifaWidth },
      { data: 'descuento_web', type: 'numeric', numericFormat: { pattern: '0,0.00' }, width: dtoWidth },
    ];

    self.hotInstance = new Handsontable(self.$refs.hotTableComponent, {
      licenseKey: 'non-commercial-and-evaluation',
      //autoRowSize: { syncLimit: 300 },
      dataSchema: { codigo: null, nombre: null },
      multiSelect: true,
      rowHeaders: true,
      width: 975,
      height: 535,
      columnSorting: true,
      sortIndicator: true,
      manualColumnResize: true,
      manualColumnMove: true,
      fillHandle: {
        //direction: 'vertical',
        autoInsertRow: false,
      },
      fixedColumnsLeft: 1,
      columns,
      colHeaders,
      colWidths,
      data: [],
      minRows: 0,
      minSpareRows: 0,
      beforeChange: (changes, source) => changes.forEach(c => changes.push([c[0], 'changed', null, 1])),
      rowHeights: 21,
      enterBeginsEditing: false,
      autoWrapCol: false,
      autoWrapRow: false,
      rowHeaderWidth,
      afterSelectionEnd: row => {
        row = self.hotInstance?.toPhysicalRow(row) || row;
        if (parseInt(self.app.config.mostrar_imagen_articulos_ocultos)) {
          let h = self.hotInstance;
          let articulo_id = h.getSourceData()[row].codigo;
          if (!articulo_id) return;
          let a = h.getSourceData()[row];
          if (self.win.children.length && self.win.children.some(ch => ch.window_name == 'popup_imagen')) {
            let popupImagen = self.win.children.find(ch => ch.window_name == 'popup_imagen');
            if (popupImagen.instance) popupImagen.instance.articulo = a;
            else popupImagen.opts.articulo = a;
          } else {
            let p = self.interactPosition;
            let $el = self.win.instance.$el;
            self.app.openChildWindow('popup_imagen', self.win, {
              backdrop: false,
              resizable: true,
              articulo: a,
              x: $el.offsetWidth + p.x,
              y: p.y
            })
          }
        }
      },
    });
    self.actualizarArticulos();
  },
};
</script>

<style>
.text-align-center {
  text-align: center;
}
</style>